import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const PennStateUniversity = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Pennsylvania State University"
      universityShortName="Penn State"
      slug="penn-state-university"
      seoTitle="Penn State Study Rooms | Pattee Library Study Spaces"
      seoDescription="Find study rooms at Penn State including Pattee and Paterno Libraries. Learn booking policies and discover CSW as an online alternative."
      seoKeywords="Penn State study rooms, Pattee Library, University Park study spaces, Nittany Lion study rooms, PSU library"
      canonicalUrl="/study-room/penn-state-university/"
      heroDescription="Navigate Penn State's extensive Pattee-Paterno library complex and Knowledge Commons."
      libraryWebsiteUrl="https://libraries.psu.edu"
      libraryWebsiteName="Penn State Libraries"
      studySpaces={[
        {
          name: "Pattee Library - Group Rooms",
          features: "Up to 3 hours/day per group, book 2 weeks ahead. Min 2 people.",
          feedback: "Good variety. Some complaints about noise in quiet areas."
        },
        {
          name: "Pattee Library - Stacks",
          features: "Deep quiet study in the book stacks, individual desks.",
          feedback: "Ultimate silence for focused work. Can feel isolated."
        },
        {
          name: "Paterno Library - Fourth Floor",
          features: "Quiet study floor, tables with built-in outlets.",
          feedback: "Great for silent study. Modern amenities."
        },
        {
          name: "Knowledge Commons",
          features: "Collaborative tables and monitors, no reservation needed.",
          feedback: "Good backup when rooms are full. More social atmosphere."
        }
      ]}
      guideContent={
        <>
          <p>
            Penn State's guideline for group study rooms permits reservations for up to three hours per day per group, 
            with bookings available two weeks in advance. Groups must consist of at least two people.
          </p>
          <p className="mt-4">
            Reservations are held for 15 minutes before being forfeited; drop-in use is allowed when rooms are free. 
            Students complain that people talk and eat loudly in the quiet areas of Pattee Library.
          </p>
          <p className="mt-4">
            Book a group room early during exam season. For quiet study, head to the Stacks or the fourth floor 
            of Paterno Library. If group rooms are full, the Knowledge Commons offers collaborative tables and 
            monitors without reservations.
          </p>
        </>
      }
      summaryTips={[
        "Book group rooms up to 2 weeks in advance",
        "Minimum 2 people required for group rooms",
        "15-minute grace period before forfeiture",
        "Paterno 4th floor and Stacks are quietest",
        "Knowledge Commons is good for drop-in study"
      ]}
    />
  );
};

export default PennStateUniversity;
